// src/components/ContactModal.js
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS for React Toastify
import { useLanguage } from "../../Context/LanguageContext";

const ContactModal = ({ show, handleClose }) => {
   const { t } = useLanguage();
   const { language } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (phone) => {
    const countryCode = phone.replace(/\D/g, "").slice(0, 2); // Extract first 2 digits as country code
    const phoneNumber = phone.replace(/\D/g, "").slice(2); // Extract remaining digits

    setFormData((prev) => ({
      ...prev,
      phone: `+${countryCode} ${phoneNumber}`, // Format as +CC XXXXXXXX
    }));
  };

 const handleSubmit = (event) => {
   event.preventDefault();

   emailjs
     .send("service_q5eshtd", "jksel_profile", formData, "0PTcBmJtp3qKmu1ph")
     .then(
       (response) => {
         toast.success("Your query has been received!"); // Show success toast
       },
       (err) => {
         toast.error("Failed to send your query. Please try again.");
       }
     )
     .finally(() => {
       setFormData({
         name: "",
         email: "",
         phone: "",
         message: "",
       });
       handleClose(); // Close the contact modal
     });
 };


  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t.contactus}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>
                {t.name} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder={t.namePlaceholder}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail" className="mt-3">
              <Form.Label>
                {t.email} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t.emailPlaceholder}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhone" className="mt-3">
              <Form.Label>
                {t.phone} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <PhoneInput
                country={language === "ko-KR" ? "kr" : "in"}
                value={formData.phone}
                onChange={handlePhoneChange}
                inputStyle={{ width: "100%" }}
                required
                placeholder={t.phonePlaceholder}
              />
            </Form.Group>

            <Form.Group controlId="formMessage" className="mt-3">
              <Form.Label>
                {t.message} <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={3}
                placeholder={t.queryPlaceholder}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="mt-3">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="top-center" // Position of the toast notifications
        autoClose={5000} // Duration in milliseconds before the toast disappears
        hideProgressBar={false} // Show progress bar
        newestOnTop={false} // Newest toast on top
        closeOnClick // Close on click
        rtl={false} // Right-to-left
        pauseOnFocusLoss // Pause when window loses focus
        draggable // Allow dragging
        pauseOnHover={false}
      />
    </>
  );
};

export default ContactModal;
